module.exports = __webpack_public_path__ + "static/MOD0-2fdfdec6ba21c6228c9fa00bc7430806.png";